// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listFiles {
  --list-files-row-padding: var(--density-row-padding);
  --list-files-icon-size: var(--density-icon-size);
  --list-files-icon-padding: var(--density-icon-padding);
  --list-files-control-padding: var(--density-control-padding);
  --list-files-font-size: var(--density-font-size);

  display: flex;
  flex-direction: column;
  /* For some reason there was still an overflow without the -1px */
  min-height: calc(100vh - var(--header-height) - 1px);
}

/* Leave room for the fixed music playback bar when it is showing. */
.appView-withPlaybackBar .listFiles {
  min-height: calc(
    100vh - var(--header-height) - 1px - var(--playback-bar-height)
  );
}

.listFilesList,
.listFilesBlocks {
  flex: 1;
  overflow: auto;
}

.listFilesList {
  position: relative;
  padding-block: 4px;

  &:focus-visible {
    outline: none;
  }
}

.listFilesBack {
  width: 20px;
  height: 20px;
  position: relative;
  display: inline-block;
  background: #0002;
  border-radius: 3px;
  text-align: center;
  padding: 4px;
  text-decoration: none;
  color: #000;
}

.listFilesBack:hover {
  background: #0003;
}

.listFilesFilter {
  --gap: 8px;
  border-bottom: 1px solid var(--line);
  display: flex;
  gap: var(--gap);
  padding: var(--gap);
}

.listFilesFilterInput {
  font-size: var(--font-size-small);
  padding: 6px 9px 6px 30px;
  flex: 1;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  /* webpackIgnore: true */
  background-image: url('/svg/search.svg');
  background-repeat: no-repeat;
  background-position: 9px center;
  background-size: 14px;
}

.listFilesFilterInput:focus-visible {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-tint);
}

.listFilesIcon {
  margin-inline-end: 8px;
  width: var(--list-files-icon-size);
  height: var(--list-files-icon-size);
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--list-files-icon-padding);

  img {
    width: calc(var(--list-files-icon-size) - 2px);
    height: calc(var(--list-files-icon-size) - 2px);
  }
}

.listFilesIconCached {
  outline: 1px solid var(--accent-tint);
}
.listFilesIconCached.listFilesFolder {
  outline: none;
}

.listFilesFile {
  display: flex;
  position: relative;
  margin-inline: 8px;
  border-radius: 6px;
  border-bottom: 1px solid var(--line);

  &:hover {
    background: var(--selection-hover);
  }

  /* Drop the hairline inside a selected run and the one directly above it. */
  &.selected,
  &:has(+ .listFilesFile.selected) {
    border-bottom-color: transparent;
  }

  &.selected {
    background: var(--selection-inactive);

    &:hover {
      background: var(--selection-inactive-hover);
    }

    .listFilesList:focus-within & {
      background: var(--selection-active);

      &:hover {
        background: var(--selection-active-hover);
      }

      & a.listFilesFileLink,
      & a.listFilesFileEmpty {
        color: #fff;
      }

      & .listFilesFolder::after {
        background-color: #fff;
      }

      & .listFilesIcon img {
        filter: invert(1);
      }

      & .listFilesFileMenuIcon {
        filter: invert(1);
      }
    }
  }

  /* Create an inset pseudo element so the outline isn't cut off. */
  &.dragging {
    outline: none;

    &::after {
      content: "";
      inset: 2px;
      position: absolute;
      border: 2px solid var(--primary-color-hover);
      border-radius: 5px;
      pointer-events: none;
    }
  }

}

a.listFilesFileLink,
a.listFilesFileEmpty {
  padding: var(--list-files-row-padding);
  font-size: var(--list-files-font-size);
  display: flex;
  text-decoration: none;
  color: #000;
  align-items: center;
  flex: 1;
  cursor: default;
}

/* Square the joins between consecutive selected rows so a run reads as one block. */
.listFilesFile.selected + .listFilesFile.selected {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.listFilesFile.selected:has(+ .listFilesFile.selected) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.listFilesBlocks {
  animation: fadein 500ms;
  height: calc(100% - var(--header-padding));
  top: var(--header-padding);
  position: absolute;
  width: 100%;
}

.listFilesFileBlock {
  padding: 16px;
  position: relative;
  border-bottom: 1px solid #ddd;
}

.listFilesFileBlock::after {
  content: "";
  height: 12px;
  background-color: #eee;
  position: relative;
  display: block;
  width: 67%;
}

.listFilesFileBlock:nth-child(1) { opacity: 100%; }
.listFilesFileBlock:nth-child(2) { opacity: 90%; }
.listFilesFileBlock:nth-child(3) { opacity: 80%; }
.listFilesFileBlock:nth-child(4) { opacity: 60%; }
.listFilesFileBlock:nth-child(5) { opacity: 40%; }

.listFilesFileBlock:nth-child(1)::after { width: 70%; }
.listFilesFileBlock:nth-child(2)::after { width: 30%; }
.listFilesFileBlock:nth-child(3)::after { width: 60%; }
.listFilesFileBlock:nth-child(4)::after { width: 55%; }
.listFilesFileBlock:nth-child(5)::after { width: 24%; }

.listFilesExtension {
  opacity: 0.6;
}


.listFilesFileMenu {
  box-sizing: border-box;
  border: 0;
  padding: 0;
  margin: 0;
  background: none;
  font-size: inherit;
  line-height: 0;
  position: relative;

  &:hover {
    border-right: 8px solid #fff;
    background-color: #eee;

    & .listFilesFileMenuIcon {
      margin-inline-end: 10px;
    }
  }
  .selected &:hover {
    border-color: transparent;
    background-color: transparent;
    background: #ffffff33;
  }

  .selected &:hover::after {
    display: none;
  }

  .file-menu-focused .selected &::after {
    content: "";
    inset: 9px 13px 9px 5px;
    pointer-events: none;
    border-radius: 3px;
    outline: 2px solid #fff;
    position: absolute;
  }

}

.listFilesFileMenuIcon {
  display: inline-block;
  /* webpackIgnore: true */
  background-image: url(/svg/three-dots.svg);
  width: 16px;
  height: 16px;
  margin-inline: 10px 18px;
}

.listFileDisplayName {
  flex: 1;
}

.listFileRename {
  flex: 1;
  display: flex;
  gap: 5px;
}

.listFileRenameInput {
  flex: 1;
  padding: var(--list-files-control-padding);
}

/* The folder mark is the one violet glyph in the otherwise-neutral list.
   The row only ever gets .listFilesFolder for real folders, so the mask URL
   can be static. */
.listFilesFolder img {
  visibility: hidden;
}

.listFilesFolder::after {
  content: "";
  position: absolute;
  inset: var(--list-files-icon-padding);
  background-color: var(--accent);
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
  /* webpackIgnore: true */
  mask-image: url('/svg/folder.svg');
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/ListFiles.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;EACpD,gDAAgD;EAChD,sDAAsD;EACtD,4DAA4D;EAC5D,gDAAgD;;EAEhD,aAAa;EACb,sBAAsB;EACtB,iEAAiE;EACjE,oDAAoD;AACtD;;AAEA,oEAAoE;AACpE;EACE;;GAEC;AACH;;AAEA;;EAEE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,wCAAwC;EACxC,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;;EAEvC;IACE,8CAA8C;IAC9C,+CAA+C;EACjD;AACF;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;;EAEpC;IACE,kCAAkC;EACpC;;EAEA,2EAA2E;EAC3E;;IAEE,gCAAgC;EAClC;;EAEA;IACE,qCAAqC;;IAErC;MACE,2CAA2C;IAC7C;;IAEA;MACE,mCAAmC;;MAEnC;QACE,yCAAyC;MAC3C;;MAEA;;QAEE,WAAW;MACb;;MAEA;QACE,sBAAsB;MACxB;;MAEA;QACE,iBAAiB;MACnB;;MAEA;QACE,iBAAiB;MACnB;IACF;EACF;;EAEA,iEAAiE;EACjE;IACE,aAAa;;IAEb;MACE,WAAW;MACX,UAAU;MACV,kBAAkB;MAClB,4CAA4C;MAC5C,kBAAkB;MAClB,oBAAoB;IACtB;EACF;;AAEF;;AAEA;;EAEE,sCAAsC;EACtC,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,OAAO;EACP,eAAe;AACjB;;AAEA,oFAAoF;AACpF;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA,mCAAmC,aAAa,EAAE;AAClD,mCAAmC,YAAY,EAAE;AACjD,mCAAmC,YAAY,EAAE;AACjD,mCAAmC,YAAY,EAAE;AACjD,mCAAmC,YAAY,EAAE;;AAEjD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,UAAU,EAAE;;AAEtD;EACE,YAAY;AACd;;;AAGA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;;EAElB;IACE,4BAA4B;IAC5B,sBAAsB;;IAEtB;MACE,uBAAuB;IACzB;EACF;EACA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;EACpB;;AAEF;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,0CAA0C;AAC5C;;AAEA;;mBAEmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;AACpC","sourcesContent":[".listFiles {\n  --list-files-row-padding: var(--density-row-padding);\n  --list-files-icon-size: var(--density-icon-size);\n  --list-files-icon-padding: var(--density-icon-padding);\n  --list-files-control-padding: var(--density-control-padding);\n  --list-files-font-size: var(--density-font-size);\n\n  display: flex;\n  flex-direction: column;\n  /* For some reason there was still an overflow without the -1px */\n  min-height: calc(100vh - var(--header-height) - 1px);\n}\n\n/* Leave room for the fixed music playback bar when it is showing. */\n.appView-withPlaybackBar .listFiles {\n  min-height: calc(\n    100vh - var(--header-height) - 1px - var(--playback-bar-height)\n  );\n}\n\n.listFilesList,\n.listFilesBlocks {\n  flex: 1;\n  overflow: auto;\n}\n\n.listFilesList {\n  position: relative;\n  padding-block: 4px;\n\n  &:focus-visible {\n    outline: none;\n  }\n}\n\n.listFilesBack {\n  width: 20px;\n  height: 20px;\n  position: relative;\n  display: inline-block;\n  background: #0002;\n  border-radius: 3px;\n  text-align: center;\n  padding: 4px;\n  text-decoration: none;\n  color: #000;\n}\n\n.listFilesBack:hover {\n  background: #0003;\n}\n\n.listFilesFilter {\n  --gap: 8px;\n  border-bottom: 1px solid var(--line);\n  display: flex;\n  gap: var(--gap);\n  padding: var(--gap);\n}\n\n.listFilesFilterInput {\n  font-size: var(--font-size-small);\n  padding: 6px 9px 6px 30px;\n  flex: 1;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  /* webpackIgnore: true */\n  background-image: url('/svg/search.svg');\n  background-repeat: no-repeat;\n  background-position: 9px center;\n  background-size: 14px;\n}\n\n.listFilesFilterInput:focus-visible {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-tint);\n}\n\n.listFilesIcon {\n  margin-inline-end: 8px;\n  width: var(--list-files-icon-size);\n  height: var(--list-files-icon-size);\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: var(--list-files-icon-padding);\n\n  img {\n    width: calc(var(--list-files-icon-size) - 2px);\n    height: calc(var(--list-files-icon-size) - 2px);\n  }\n}\n\n.listFilesIconCached {\n  outline: 1px solid var(--accent-tint);\n}\n.listFilesIconCached.listFilesFolder {\n  outline: none;\n}\n\n.listFilesFile {\n  display: flex;\n  position: relative;\n  margin-inline: 8px;\n  border-radius: 6px;\n  border-bottom: 1px solid var(--line);\n\n  &:hover {\n    background: var(--selection-hover);\n  }\n\n  /* Drop the hairline inside a selected run and the one directly above it. */\n  &.selected,\n  &:has(+ .listFilesFile.selected) {\n    border-bottom-color: transparent;\n  }\n\n  &.selected {\n    background: var(--selection-inactive);\n\n    &:hover {\n      background: var(--selection-inactive-hover);\n    }\n\n    .listFilesList:focus-within & {\n      background: var(--selection-active);\n\n      &:hover {\n        background: var(--selection-active-hover);\n      }\n\n      & a.listFilesFileLink,\n      & a.listFilesFileEmpty {\n        color: #fff;\n      }\n\n      & .listFilesFolder::after {\n        background-color: #fff;\n      }\n\n      & .listFilesIcon img {\n        filter: invert(1);\n      }\n\n      & .listFilesFileMenuIcon {\n        filter: invert(1);\n      }\n    }\n  }\n\n  /* Create an inset pseudo element so the outline isn't cut off. */\n  &.dragging {\n    outline: none;\n\n    &::after {\n      content: \"\";\n      inset: 2px;\n      position: absolute;\n      border: 2px solid var(--primary-color-hover);\n      border-radius: 5px;\n      pointer-events: none;\n    }\n  }\n\n}\n\na.listFilesFileLink,\na.listFilesFileEmpty {\n  padding: var(--list-files-row-padding);\n  font-size: var(--list-files-font-size);\n  display: flex;\n  text-decoration: none;\n  color: #000;\n  align-items: center;\n  flex: 1;\n  cursor: default;\n}\n\n/* Square the joins between consecutive selected rows so a run reads as one block. */\n.listFilesFile.selected + .listFilesFile.selected {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.listFilesFile.selected:has(+ .listFilesFile.selected) {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.listFilesBlocks {\n  animation: fadein 500ms;\n  height: calc(100% - var(--header-padding));\n  top: var(--header-padding);\n  position: absolute;\n  width: 100%;\n}\n\n.listFilesFileBlock {\n  padding: 16px;\n  position: relative;\n  border-bottom: 1px solid #ddd;\n}\n\n.listFilesFileBlock::after {\n  content: \"\";\n  height: 12px;\n  background-color: #eee;\n  position: relative;\n  display: block;\n  width: 67%;\n}\n\n.listFilesFileBlock:nth-child(1) { opacity: 100%; }\n.listFilesFileBlock:nth-child(2) { opacity: 90%; }\n.listFilesFileBlock:nth-child(3) { opacity: 80%; }\n.listFilesFileBlock:nth-child(4) { opacity: 60%; }\n.listFilesFileBlock:nth-child(5) { opacity: 40%; }\n\n.listFilesFileBlock:nth-child(1)::after { width: 70%; }\n.listFilesFileBlock:nth-child(2)::after { width: 30%; }\n.listFilesFileBlock:nth-child(3)::after { width: 60%; }\n.listFilesFileBlock:nth-child(4)::after { width: 55%; }\n.listFilesFileBlock:nth-child(5)::after { width: 24%; }\n\n.listFilesExtension {\n  opacity: 0.6;\n}\n\n\n.listFilesFileMenu {\n  box-sizing: border-box;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  background: none;\n  font-size: inherit;\n  line-height: 0;\n  position: relative;\n\n  &:hover {\n    border-right: 8px solid #fff;\n    background-color: #eee;\n\n    & .listFilesFileMenuIcon {\n      margin-inline-end: 10px;\n    }\n  }\n  .selected &:hover {\n    border-color: transparent;\n    background-color: transparent;\n    background: #ffffff33;\n  }\n\n  .selected &:hover::after {\n    display: none;\n  }\n\n  .file-menu-focused .selected &::after {\n    content: \"\";\n    inset: 9px 13px 9px 5px;\n    pointer-events: none;\n    border-radius: 3px;\n    outline: 2px solid #fff;\n    position: absolute;\n  }\n\n}\n\n.listFilesFileMenuIcon {\n  display: inline-block;\n  /* webpackIgnore: true */\n  background-image: url(/svg/three-dots.svg);\n  width: 16px;\n  height: 16px;\n  margin-inline: 10px 18px;\n}\n\n.listFileDisplayName {\n  flex: 1;\n}\n\n.listFileRename {\n  flex: 1;\n  display: flex;\n  gap: 5px;\n}\n\n.listFileRenameInput {\n  flex: 1;\n  padding: var(--list-files-control-padding);\n}\n\n/* The folder mark is the one violet glyph in the otherwise-neutral list.\n   The row only ever gets .listFilesFolder for real folders, so the mask URL\n   can be static. */\n.listFilesFolder img {\n  visibility: hidden;\n}\n\n.listFilesFolder::after {\n  content: \"\";\n  position: absolute;\n  inset: var(--list-files-icon-padding);\n  background-color: var(--accent);\n  mask-position: center;\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  /* webpackIgnore: true */\n  mask-image: url('/svg/folder.svg');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
